import moment from "moment";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import Button from "../../components/Button";
import Heading from "../../components/Heading";

import fetchApplicationsExcel from "../../services/fetchApplicationsExcel";

import user from "../../store/user";
import {getQueryParams} from "../../utils/utilFunctions";
import "./styles.scss";
import InputBox from "../../components/InputBox";

const BulkApplicationDownload = (props) => {
    const [recId, setRecId] = useState("");
    const [searchJobId, setSearchJobId] = useState("");
    const PAGE_CONTENT = 2000;

    useEffect(() => {
        const params = getQueryParams(props.location.search);
        if(params.jobId)
            setSearchJobId(params.jobId.trim());
        if(params.recId)
            setRecId(params.recId);
    }, [])

    const getApplications = async() => {
        let jobIdArray = [];
        if(searchJobId)
        {
            jobIdArray = searchJobId.trim().split(",").map(id => id.trim());
            props.history.push({
                pathname: "/bulkApplicationDownload",
                search: `?jobId=${searchJobId}&recId=${recId}`
            });

        }
        for(let jobId of jobIdArray)
        {
            if(!jobId || !recId) 
                return;
            try {
                const profile = await user.getProfile();
                const res = await fetchApplicationsExcel(profile.id, {jobId, recId,
                    offset: 0,
                    pageContent: PAGE_CONTENT
                });
                var blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
                var url = URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', `${process.env.REACT_APP_PLATFORM}_${jobId}_report.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (e) {
                console.log(e);
            }
        }
    }
    return (
        <div className="bulk-applications-wrapper">
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable={false}
                pauseOnHover
            />

            <div className="pageHeading">
                <Heading text="Bulk Application Download" />
            </div>
            <div className="input-search-field">
                <div className="job-id-search-field">
                    <InputBox
                        type="text"
                        placeholder="Enter Job Id's"
                        value={searchJobId}
                        onChange={(e) => setSearchJobId(e.target.value.trim())}
                    />
                    <InputBox
                        type="text"
                        placeholder="Enter Recruiter Id"
                        value={recId}
                        onChange={(e) => setRecId(e.target.value)}
                    />
                    <Button
                        className="download_excel"
                        skin="dark"
                        disabled={false}
                        text="Download"
                        clickButton={getApplications}
                    />
                </div>   
            </div>         
        </div>  
    );
};

export default BulkApplicationDownload;